module.exports = __webpack_public_path__ + "img/pollen-md.7ff08291.png";